module.exports = __webpack_public_path__ + "static/media/cil-truck.dc85dea3.svg";